import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import VehicleMain from '../../components/vehicle/VehicleMain'
import Footer from '../../components/common/Footer'
export default function VehiclePage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <VehicleMain />
            <Footer/>
        </>
    )
}



